import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ISearchResult } from 'app/models/well/search/search.result';
import { VoucherService } from 'app/services/voucher-service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'missing-lat-long-report',
  templateUrl: './missing-lat-long.component.html',
  styleUrls: ['./missing-lat-long.component.scss']
})
export class MissingLatLongComponent implements OnInit {
  loading: boolean = false;  
  size: number = 0;
  searchResults: ISearchResult[] = [];
  
  displayedColumns: string[] = ['wellId','wellAddress1', 'wellCity', 'wellZip', 'wellCounty','actions'];
  dataSource = new MatTableDataSource<ISearchResult>(this.searchResults);
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(private voucherService: VoucherService,
    public dialog: MatDialog,
    private toastr: ToastrService ) { 
  }

  ngOnInit(): void {
    this.loadReport();
  }
  
  loadReport() {
    this.loading = true;

    this.voucherService.getMissingLatLongReport().subscribe(
      result => {
        this.searchResults = result;
        this.size = result.length;
        this.loading = false;
      },
      error => {
        this.toastr.error(error.message)
        this.loading = false;
      },
      () => {
        this.dataSource = new MatTableDataSource<ISearchResult>(this.searchResults);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  findLatLong(wellId: number) {
    this.loading = true;

    this.voucherService.lookupWellLatLong(wellId).subscribe(
      result => {        
        this.loadReport();
      },
      error => {
        this.toastr.error(error.message)
        this.loading = false;
      }
    );
  }
}